import { Col } from "antd";
import React from "react";

const ErrorComponent = ({ errorMessage }) => {
  return <Col className="ERROR pl-0">{errorMessage}</Col>;
};

export default ErrorComponent;
